import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { LEGEND_COLORS } from "@/dashboard/constants";

interface LegendLabelProps {
  label: string;
  type: keyof typeof LEGEND_COLORS;
}

export const LegendLabel = ({ label, type }: LegendLabelProps) => (
  <Stack direction="row" align="center" gap={1} className="whitespace-nowrap">
    <span
      aria-hidden="true"
      className={cn("size-2 rounded-full", LEGEND_COLORS[type])}
    />
    <Text variant="caption" tone="muted">
      {label}
    </Text>
  </Stack>
);
